import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import styles from './StatusHeader.module.scss';

const StatusHeader = ({ value, setValue, returnStatuses }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event, newValue) => {
    const idxBeforeParam = location.pathname.lastIndexOf('/');
    navigate(location.pathname.substr(0, idxBeforeParam + 1) + newValue);
    setValue(returnStatuses[newValue]);
  };

  return (
    <div className={styles.tabsWrapper}>
      <Tabs
        value={value?.idReturnStatus || 0}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="basic tabs example">
        {returnStatuses?.map((status) => (
          <Tab
            key={status.name}
            className={styles.item}
            icon={<div className={styles.count}>{status.count}</div>}
            iconPosition="top"
            label={status.name}
          />
        ))}
      </Tabs>
    </div>
  );
};

export default StatusHeader;
